import { useMutation } from "@tanstack/react-query";
import { panelDelete } from "common/api/unos_rad/unos_panel";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnosPanelDeleteParams = {
  invalidateKeys?: string[];
};

export const useUnosPanelDelete = (hookParams?: UseUnosPanelDeleteParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: panelDeleteMutate } = useMutation({
    mutationFn: async (id: string) => await panelDelete(id),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
    },
  });

  return { panelDeleteMutate };
};
